import axios from 'axios'

import { addNotification } from 'redux/modules/notifier'
import getMessage from './getMessage'
import getKey from './getKey'
import history from 'utils/history'

// Mesmo bucket de tempo usado em getKey, para evitar notificações duplicadas
// quando várias requisições falham juntas por causa da mesma queda de rede.
const NETWORK_ERROR_KEY_COEFF = 2500

const getNetworkErrorKey = () =>
  `network_error_${Math.round(Date.now() / NETWORK_ERROR_KEY_COEFF) * NETWORK_ERROR_KEY_COEFF}`

const getRawToken = () => {
  if (!localStorage.token) return null
  const token = JSON.parse(localStorage.token)
  return token.jwt
}

export default {
  setupInterceptors: (store, instance = axios) => {
    instance.interceptors.response.use(
      function (response) {
        const message = getMessage(response)
        const key = getKey(response)

        if (message && key && !response.config?.silent) {
          store.dispatch(
            addNotification({
              key,
              message,
              options: { variant: 'success' },
            })
          )
        }

        return Promise.resolve(response)
      },
      function (error) {
        // Sem error.response = a requisição nunca recebeu resposta do servidor
        // (Wi-Fi/dados caindo, DNS, CORS, etc.), não um erro HTTP propriamente dito.
        // O browser não expõe qual desses motivos foi — navigator.onLine é o único
        // sinal disponível para não afirmar "sua internet" quando pode ser DNS/CORS.
        if (!error.response) {
          if (!error.config?.silent) {
            store.dispatch(
              addNotification({
                key: getNetworkErrorKey(),
                message: navigator.onLine
                  ? 'Não foi possível conectar ao servidor. Tente novamente em instantes.'
                  : 'Falha de conexão. Verifique sua internet e tente novamente.',
                options: { variant: 'error' },
              })
            )
          }

          return Promise.reject(error)
        }

        const message = getMessage(error.response, false)
        const key = getKey(error.response)

        if (message && key && !error.config?.silent) {
          store.dispatch(
            addNotification({
              key,
              message,
              options: { variant: 'error' },
            })
          )
        }

        if (error.response.status === 401) {
          history.push('/session/destroy')
        }

        return Promise.reject(error)
      }
    )

    instance.interceptors.request.use(function (config) {
      config.headers['Authorization'] = `Bearer ${getRawToken()}`
      return config
    })
  },
}
